import { yiluTracking } from 'utils';
import { extractUserAgentInfo } from 'utils/extractDeviceType';
import { getVariables } from 'utils/yiluEnv';

import { BasePayload, EventParam, EventType, GA4_TRACKING, PostTracking } from './types';

export const createBasePayload = (
  touchpointType: string,
  productCardOrder: string,
): BasePayload => {
  const yiluEnv = getVariables();
  const ep = yiluEnv.YILU_ENTERPRISE_PARTNER?.toLowerCase();
  const url = window.location.origin + window.location.pathname;
  const deviceType = extractUserAgentInfo(window.navigator.userAgent);

  return {
    url,
    deviceType,
    integrationType: touchpointType,
    productCardOrder,
    ep,
  };
};

export async function postTracking(payload: PostTracking) {
  const yiluEnv = getVariables();
  const baseURL = yiluEnv.YILU_AMP_BACKEND_URL;

  try {
    await fetch(`${baseURL}/v1/tracking/promotion/event`, {
      method: 'POST',
      body: JSON.stringify(payload),
      headers: {
        'Content-Type': 'application/json',
      },
    });
  } catch (error) {
    console.warn('The tracking does not work');
  }
}

export const triggerEvent = (
  eventType: EventType,
  eventParam: EventParam,
  basePayload: BasePayload,
): void => {
  if (typeof window !== 'undefined') {
    const payload = {
      ...basePayload,
      eventType,
      eventParam,
    };
    postTracking(payload);
  }
};

export const sendCardBknEvent = (productKey: keyof typeof GA4_TRACKING) => {
  const { label, bkn } = GA4_TRACKING[productKey];
  yiluTracking.sendGAEvent({
    event: 'stopover_cta_clicked',
    category: 'stopover',
    label,
    value: bkn,
  });
};

export const sendCardInfEvent = (productKey: keyof typeof GA4_TRACKING) => {
  const { label, inf } = GA4_TRACKING[productKey];
  yiluTracking.sendGAEvent({
    event: 'stopover_info_clicked',
    category: 'stopover',
    label,
    value: inf,
  });
};
